/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteTestGroupDto } from "./QuoteTestGroupDto";
import {
  QuoteTestGroupDtoFromJSON,
  QuoteTestGroupDtoFromJSONTyped,
  QuoteTestGroupDtoToJSON,
  QuoteTestGroupDtoToJSONTyped,
} from "./QuoteTestGroupDto";
import type { QuoteTestScenarioDetailsDto } from "./QuoteTestScenarioDetailsDto";
import {
  QuoteTestScenarioDetailsDtoFromJSON,
  QuoteTestScenarioDetailsDtoFromJSONTyped,
  QuoteTestScenarioDetailsDtoToJSON,
  QuoteTestScenarioDetailsDtoToJSONTyped,
} from "./QuoteTestScenarioDetailsDto";

/**
 *
 * @export
 * @interface ExportQuoteGroupData
 */
export interface ExportQuoteGroupData {
  /**
   *
   * @type {QuoteTestGroupDto}
   * @memberof ExportQuoteGroupData
   */
  group: QuoteTestGroupDto;
  /**
   *
   * @type {Array<QuoteTestScenarioDetailsDto>}
   * @memberof ExportQuoteGroupData
   */
  scenarioDetails: Array<QuoteTestScenarioDetailsDto>;
}

/**
 * Check if a given object implements the ExportQuoteGroupData interface.
 */
export function instanceOfExportQuoteGroupData(
  value: object,
): value is ExportQuoteGroupData {
  if (!("group" in value) || value["group"] === undefined) return false;
  if (!("scenarioDetails" in value) || value["scenarioDetails"] === undefined)
    return false;
  return true;
}

export function ExportQuoteGroupDataFromJSON(json: any): ExportQuoteGroupData {
  return ExportQuoteGroupDataFromJSONTyped(json, false);
}

export function ExportQuoteGroupDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExportQuoteGroupData {
  if (json == null) {
    return json;
  }
  return {
    group: QuoteTestGroupDtoFromJSON(json["group"]),
    scenarioDetails: (json["scenarioDetails"] as Array<any>).map(
      QuoteTestScenarioDetailsDtoFromJSON,
    ),
  };
}

export function ExportQuoteGroupDataToJSON(json: any): ExportQuoteGroupData {
  return ExportQuoteGroupDataToJSONTyped(json, false);
}

export function ExportQuoteGroupDataToJSONTyped(
  value?: ExportQuoteGroupData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    group: QuoteTestGroupDtoToJSON(value["group"]),
    scenarioDetails: (value["scenarioDetails"] as Array<any>).map(
      QuoteTestScenarioDetailsDtoToJSON,
    ),
  };
}
